const Skills = ({ text }) => {
  return (
    <div className="flex items-center justify-center w-full px-3 py-3 bg-zinc-200 text-gray-800 font-semibold rounded">
      <span>{text}</span>
    </div>
  );
};

export default Skills;
